import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-input',
  template: `
    <p class="input-title" *ngIf="title">{{ title }}</p>
    <input
      class="form-input {{ customClass }}{{noValidate ? 'ignore-valid' : ''}}"
      [type]="type"
      [placeholder]="placeholder"
      [(ngModel)]="value"
      [attr.checked]="value"
      (blur)="onBlur()"
      [maxlength]="maxlength"
      [disabled]="disabled"
      [readonly]="readonly"
      autocomplete="off"
    />
    <div class="input-icon-wrapper" *ngIf="showIcons" [class.--eye]="(type === 'password' && eye) || eyeToggler">
      <div class="input-eye" *ngIf="(type === 'password' && eye) || eyeToggler" (click)="toggleEye()">
        <i class="fa fa-eye" *ngIf="!eyeToggler"></i> <i class="fa fa-eye-slash" *ngIf="eyeToggler"></i>
      </div>
    </div>
    <p class="input-error" *ngIf="error">{{ error }}</p>
  `,
  styleUrls: ['./form-input.template.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormInputComponent),
      multi: true,
    },
  ],
})
export class FormInputComponent implements ControlValueAccessor {
  @Input() title: string;
  @Input() type: string = 'text';
  @Input() disabled: boolean = false;
  @Input() readonly: boolean = false;
  @Input() placeholder: string = '';
  @Input() error: string = '';
  @Input() eye: boolean = true;
  @Input() maxlength: number = 256;
  @Input() customClass: string = '';
  @Input('no-validate') noValidate: boolean = false;
  @Input('show-icons') showIcons: boolean = true;
  @Input('value') _value = '';
  @Output('blur') blurEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  eyeToggler: boolean = false;

  toggleEye() {
    this.eyeToggler = !this.eyeToggler;
    if (this.eyeToggler) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }

  onChange: any = () => {};
  onTouched: any = () => {};

  get value() {
    return this._value;
  }

  set value(val: any) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  constructor(public element: ElementRef) {}

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  writeValue(value: any) {
    if (value !== undefined) {
      this.value = value;
    }
  }

  onBlur() {
    this.blurEvent.emit(true);
    this.onTouched();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-input.component.ts